import { render, staticRenderFns } from "./BackgroundColorEditor.vue?vue&type=template&id=eeb17e2e&scoped=true"
import script from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
import style0 from "./BackgroundColorEditor.vue?vue&type=style&index=0&id=eeb17e2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb17e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb17e2e')) {
      api.createRecord('eeb17e2e', component.options)
    } else {
      api.reload('eeb17e2e', component.options)
    }
    module.hot.accept("./BackgroundColorEditor.vue?vue&type=template&id=eeb17e2e&scoped=true", function () {
      api.rerender('eeb17e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/BackgroundColorEditor.vue"
export default component.exports